import {getUrl} from "react-use-websocket/dist/lib/get-url";

export class RocketChatHttpClient {
  constructor(
    private readonly hostname: string = 'chat.miep.online',
  ) {
  }

  async deleteMessage(userId: string, token: string, conversationId: string, messageId: string): Promise<void> {
    const url = this.getUrl(`/api/v1/chat.delete`)
    const body = JSON.stringify({
      roomId: conversationId,
      msgId: messageId,
      asUser: true,
    })
    await fetch(url.toString(), {
      method: 'POST',
      headers: {
        'X-Auth-Token': token,
        'X-User-Id': userId,
        'Content-Type': 'application/json',
      },
      body: body,
    })
  }

  async uploadAttachment(userId: string, token: string, conversationId: string, attachment: File, message?: string): Promise<void> {
    const uploadUrl = this.getUrl(`/api/v1/rooms.media/${conversationId}`)
    const body = new FormData()
    body.append('file', attachment)
    const uploadRes = await fetch(uploadUrl.toString(), {
      method: 'POST',
      headers: {
        'X-Auth-Token': token,
        'X-User-Id': userId,
      },
      body,
    })
    const { file } = await uploadRes.json()

    const confirmUrl = this.getUrl(`/api/v1/rooms.mediaConfirm/${conversationId}/${file._id}`)
    await fetch(confirmUrl.toString(), {
      method: 'POST',
      headers: {
        'X-Auth-Token': token,
        'X-User-Id': userId,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(message ? { msg: message } : {}),
    })
  }

  formatMediaUrl(userId: string, token: string, path: string): string {
    const url = this.getUrl(path)
    url.searchParams.set('rc_uid', userId)
    url.searchParams.set('rc_token', token)
    return url.toString()
  }

  private getUrl(path: string): URL {
    return new URL(path, `https://${this.hostname}`)
  }
}